module.exports = __webpack_public_path__ + "static/media/load.5f36b0fd.gif";